// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-card.theme--dark[data-v-09a34464],.v-card.theme--light[data-v-09a34464]{background-color:#fff!important}", ""]);
// Exports
module.exports = exports;
